const searchAc = document.getElementById('search_ac');
const searchPv = document.getElementById('search_pv');

if ( searchAc ) {
    searchAc.addEventListener('change', e => {
       if ( e.currentTarget.value == '' ) {
           searchPv.innerHTML = `<option value="">지방선택</option>`;
           return false;
       }

       getProvinces(e.currentTarget.value)
           .then(r=>{
               searchPv.innerHTML = '';
               searchPv.appendChild(makeOption(r.data));
           })
           .catch(err=>{
               console.log( err.response ? err.response : ( err.request ? err.request : err ) );
               alert('지방 목록을 가져오지 못했습니다.');
           });
    });
}


if ( current_ac != '' )
{
    searchAc.value = current_ac;

    getProvinces(current_ac)
        .then( r => {
            searchPv.innerHTML = '';
            searchPv.appendChild(makeOption(r.data));
            searchPv.value = current_pv;
        })
        .catch(err=>{
            console.log( err.response ? err.response : ( err.request ? err.request : err ) );
            alert('지방 목록을 가져오지 못했습니다.');
        });
}

if ( currentSearchType != '' )
{
    const searchType = document.getElementById('search_type');
    if ( searchType ) {
        searchType.value = currentSearchType;
    }
}